import { MAIN_BG_COLOR, MAIN_COLOR, MAIN_HOVER_COLOR } from 'shared/consts';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
   
    :root {
		font-family: "Open Sans", sans-serif;
        font-weight: 400;

        font-synthesis: none;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

    }

    body {
        height: 100%;
        margin: 0;
        background: ${MAIN_BG_COLOR};
        color: black;
        overflow: clip;
    }

    .rdp {
        --rdp-accent-color: #7747ff;
        position: absolute;
        background: white;
        box-shadow: 0px 4px 12px -3px #8f8f8f;
        border-radius: 24px;
    }

    .rdp-day_selected {
        background: ${MAIN_COLOR};
        
    }

    .rdp-day_selected:hover {
        background: ${MAIN_HOVER_COLOR}
    }

    input {
        font-family: "Roboto", sans-serif;
    }

    ul {
        list-style-type: none;
    }

    a {
        font-weight: 500;
        color: #7747FF;
        text-decoration: inherit;
    }

    a:hover {
        color: #5733bf;
    }

    h1 {
        font-size: 3.2em;
        line-height: 1.1;
    }

    button {
        border: 1px solid transparent;
        font-family: inherit;
        font-size: 15px;
        border-radius: 4px;
        cursor: pointer;
        transition: border-color 0.25s;
        background-color: unset;
    }


    @media (prefers-color-scheme: light) {
        :root {
            color: #213547;
            background-color: #ffffff;
        }
        a:hover {
            color: #5733bf;
        }
    }

    * {
        scrollbar-width: thin;
        scrollbar-color: ${MAIN_COLOR} #f1f1f1;
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }
        
    #root {
      overflow: clip;
    }
      
    ._skeleton {
      overflow: hidden;
      position: relative;
      pointer-events: none;
      >* {
        position: relative;
        z-index: 1;
      }

      &::before{
        content:'';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #d8d8d8;
        z-index: 2;
      }
      
      &::after{
        content:'';
        position: absolute;
        top: -5%;
        left: calc(100% + 60px);
        width: 40px;
        height: 110%;
        rotate: 15deg;
        background-color: #fff;
        box-shadow: 0px 0px 10px 10px rgba(255, 255, 255, 1);
        z-index: 3;
        opacity: 0.4;
        animation: skeletonAfterAnim 1s ease infinite;
      }
    }

    @keyframes skeletonAfterAnim {
      from {
          left: -3.75rem
      }
    }
`;
